import {uint8ArrayToBase64} from '../../../utils/arrayUtils';

export default function channelIdToParam(channelId?: Uint8Array | null): string {
  return encodeURIComponent(uint8ArrayToBase64(channelId));
}